module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-Regular-04a9212b780b1f1acb8c9451e6e40a76.woff2";